<script>
const sidebarMenu = [
  // { path: '/accountListAlert', icon: 'fa fa-th', title: 'ui.account_list_alert' },
  { path: '/stock', icon: 'fa fa-star', title: 'ui.total_bet', pages: [config.accessRoles.stock],
    children: [
      { path: '/betListHDPOU', title: 'ui.hdpou', pages: [config.accessRoles.stock] },
      { path: '/betListOXTOEML', title: 'ui.oxtoeml', pages: [config.accessRoles.stock] },
      { path: '/betListCS', title: 'ui.correct_score', pages: [config.accessRoles.stock] },
      { path: '/betListTG', title: 'ui.total_goal', pages: [config.accessRoles.stock] },
      { path: '/betListHTFT', title: 'ui.htft', pages: [config.accessRoles.stock] },
      { path: '/betListDC', title: 'ui.double_chance', pages: [config.accessRoles.stock] },
      { path: '/betListFGLG', title: 'ui.fglg', pages: [config.accessRoles.stock] },
      { path: '/betList', title: 'ui.bet_list', pages: [config.accessRoles.stock] },
      { path: '/betList4d', title: 'ui.bet_list_4d', pages: [config.accessRoles.stock] },
      { path: '/betListESports2', title: 'ui.bet_list_esports2', pages: [config.accessRoles.stock] },
      { path: '/memberOutstanding', title: 'ui.member_outstanding', pages: [config.accessRoles.stock] },
      { path: '/memberOutstanding4d', title: 'ui.member_outstanding_4d', pages: [config.accessRoles.stock] }
    ]
  },
  ['MMK','MMO'].includes(store.getters.getAccountCurrency) ? { path: '/forecast', icon: 'fa fa-chart-line', title: 'ui.forecast_soccer', pages: [config.accessRoles.forecast],
    children: [
      { path: '/forecastHDPList', title: 'forecastHDP', pages: [config.accessRoles.forecast] },
      { path: '/forecastHDPMMOList', title: 'forecastHDPMMO', pages: [config.accessRoles.forecast] },
      { path: '/forecastOXTList', title: 'forecastOXT', pages: [config.accessRoles.forecast] },
      { path: '/forecastOUList', title: 'forecastOU', pages: [config.accessRoles.forecast] },
      { path: '/forecastOUMMOList', title: 'forecastOUMMO', pages: [config.accessRoles.forecast] },
      { path: '/forecastOEList', title: 'forecastOE', pages: [config.accessRoles.forecast] }
    ]
  } : { path: '/forecast', icon: 'fa fa-chart-line', title: 'ui.forecast_soccer', pages: [config.accessRoles.forecast],
    children: [
      { path: '/forecastHDPList', title: 'forecastHDP', pages: [config.accessRoles.forecast] },
      { path: '/forecastOXTList', title: 'forecastOXT', pages: [config.accessRoles.forecast] },
      { path: '/forecastOUList', title: 'forecastOU', pages: [config.accessRoles.forecast] },
      { path: '/forecastOEList', title: 'forecastOE', pages: [config.accessRoles.forecast] }
    ]
  },
  { path: '/account', icon: 'fa fa-users', title: 'ui.member_management', pages: [config.accessRoles.editAccount, config.accessRoles.account, config.accessRoles.subAccount],
    children: [
      { path: '/newAccount', title: 'ui.new_account', pages: [config.accessRoles.editAccount] },
      { path: '/accountList', title: 'ui.account_list', pages: [config.accessRoles.account] },
      { path: '/subAccount', title: 'ui.sub_account', pages: [config.accessRoles.subAccount] },
      { path: '/partnerList', title: 'ui.partner_list', pages: [config.accessRoles.account], requirePartner: true }
    ]
  },
  { path: '/report', icon: 'fa fa-list-alt', title: 'ui.report', pages: [config.accessRoles.report],
    children: [
      { path: '/dailyWinlose', title: 'ui.daily_winlose_simple', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseDetail', title: 'ui.daily_winlose_details', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseByMatchDetail', title: 'ui.daily_winlose_match', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseByPlatformDetail', title: 'ui.daily_winlose_platform', pages: [config.accessRoles.report] },
      // { path: '/gameResult', title: 'ui.game_result', pages: [config.accessRoles.report] },
      { path: '/gameResultDetail', title: 'ui.game_result', pages: [config.accessRoles.report] },
      { path: '/dailyStatementMember', title: 'ui.daily_statement', pages: [config.accessRoles.report] },
      { path: '/cancelledBetList', title: 'ui.cancelled_bet_list', pages: [config.accessRoles.report] },
      { path: '/settlementHistory', title: 'ui.transfer_history', pages: [config.accessRoles.report] },
      { path: '/matchResult', title: 'ui.match_result', pages: [config.accessRoles.report] },
      { path: '/systemParlay', title: 'ui.system_parlay', pages: [config.accessRoles.report] },
      { path: '/tournamentJackpot', title: 'ui.tournament_jackpot', pages: [config.accessRoles.report] },
      { path: '/tournamentRefundList', title: 'ui.tournament_refund_list', pages: [config.accessRoles.report] }
    ]
  },
  !['MMK','MMO'].includes(store.getters.getAccountCurrency) ? { path: '/settlement', icon: 'fa fa-calculator', title: 'ui.transfer', pages: [config.accessRoles.settlement],
    children: [
      { path: '/settlementList', title: 'ui.transfer_list', pages: [config.accessRoles.settlement] }
    ]
  } : {},
  { path: '/logs', icon: 'fa fa-hdd', title: 'ui.logs', pages: [config.accessRoles.log],
    children: [
      { path: '/accessLog', title: 'ui.access_log', pages: [config.accessRoles.log] },
      { path: '/accountLog', title: 'ui.account_log', pages: [config.accessRoles.log] },
      { path: '/memberLog', title: 'ui.member_log', pages: [config.accessRoles.log] },
      { path: '/positionTakingLog', title: 'ui.position_taking_log', pages: [config.accessRoles.log] },
      { path: '/commissionLog', title: 'ui.commission_log', pages: [config.accessRoles.log] },
      { path: '/betLimitLog', title: 'ui.bet_limit_log', pages: [config.accessRoles.log] },
      { path: '/transactionLog', title: 'ui.transaction_log', pages: [config.accessRoles.log] },
      { path: '/accountActionLog', title: 'ui.account_action_log', pages: [config.accessRoles.accountActionLog] }
    ]
  }
]
import config from "@/config";
import store from "@/store";
export default sidebarMenu;
</script>
